import React, {Component} from 'react';
import {SortableContainer} from 'react-sortable-hoc';
import SortableSubjectsItem from './SortableSubjectsItem';

class SortableSubjectsContainer extends Component {
    render() {

        if(this.props.items) {
            return (
                <div className="sortable-subject-container">
                    {this.props.items.map((sub, i) => {
                        let fs = this.props.fullSubjects.filter(s => s.id === sub);
                        if(fs.length > 0){
                            fs = fs[0];
                        }else{
                            fs = {};
                        }

                        return (

                            <SortableSubjectsItem
                                index={i}
                                key={i}
                                number={i}
                                subject={sub}
                                fs={fs}
                                

                            />

                        )

                    })}
                </div>
            )
        }

    }

}

export default SortableContainer(SortableSubjectsContainer);


// WEBPACK FOOTER //
// ./src/components/AdminPanel/Strategy/SortableSubjectsContainer.js